/** Breakpoints to MediaQueries */
export var createMediaQueries = function (breakpoints) {
    var res = {};
    Object.keys(breakpoints).forEach(function (key) {
        res[key] = "@media (min-width:" + breakpoints[key] + "px)";
    });
    return res;
};
//# sourceMappingURL=mq.js.map